/**
 * Development-only logging utility
 * All logs are automatically stripped in production builds
 */

export const logger = {
  log: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.info(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.debug(...args);
    }
  }
};

// Type-safe logging with categories
export const createLogger = (category: string) => ({
  log: (...args: any[]) => logger.log(`[${category}]`, ...args),
  error: (...args: any[]) => logger.error(`[${category}]`, ...args),
  warn: (...args: any[]) => logger.warn(`[${category}]`, ...args),
  info: (...args: any[]) => logger.info(`[${category}]`, ...args),
  debug: (...args: any[]) => logger.debug(`[${category}]`, ...args)
});
